/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import CardHeader from "../../../components/CardHeader";
import Toast from "../../../components/Toast";
import { formatAdjustedDate } from "../../../CommonMethods/formatDate";
import LedgerTable from './Components/LedgerTable'
import NavBar from "./Components/NavBar";
import SubLedgerTable from "./Components/SubLedgerTable";
import InventoryTable from "../Components/InventoryTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from "../../../services/data.services";
import CustomOverLay from "../../../components/CustomOverlay";
import Filter from "../Components/TopbarComponents/Filter";
import GlobalContext from "../../../components/Context/GloablContext";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import ItemShimmer from "../../../components/Shimmer/itemShimmer";
import SubInventoryTable from "../Components/SubInventoryTable";
import ShimmerLedgerTable from "../Components/LedgerTableShimmer";
import TransactionTable from "./Components/TransactionTable";
import Loader from "../../../components/Loader";
import moment from 'moment';

const BalanceSheet = ({type}) => { 
    const [searchParams, setSearchParams] = useSearchParams('')
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const navigate = useNavigate('')
    const [finacialYear, setFinacialYear] = useState('')
    const [academicYears, setAcademicYears] = useState('')
    const [loading, setLoading] =useState(true) 
    const [exportBtnLoading, setExportBtnLoading] = useState(false)
    const [ledgerTableloading, setLedgerTableLoading] = useState(false)
    const [inventoryTableLoading, setInventoryTableLoading] = useState(false)
    const [subInventoryTableLoading, setSubInventoryTableLoading] = useState(false)
    const [subLedgerWithGroupsLoading, setSubLedgerWithGroupseLoading] = useState(false)
    const [transactionTableLoading, setTransactionTableLoading] = useState(false)
    const [subLedgerLoading, setSubLedgerLoading] = useState(false)
    const [infiniteScrollLoading, setInfiniteScrollLoading] = useState(false)
    const [subLedgerWithGroupsHasMoreData, setSubLedgerWithGroupsHasMoreData] = useState(true);//this is for the infinte scroll
    const [subLedgerHasMoreData, setSubLedgerHasMoreData] = useState(true);//this is for the infinte scroll
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({date_range : [],});
    const [filterCount, setFilterCount] = useState(0)
    const [isSchemeLedger, setIsSchemeLedger] = useState(false)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [pageType, setPageType] = useState(type)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [balanceSheetStartDate, setBalanceSheetStartDate] = useState(null)
    const [balanceSheetEndDate, setBalanceSheetEndDate] = useState(null)
    const [balancesheet, setBalanceSheet] = useState({})
    const [subLedgerData, setSubLedgerData] = useState([])
    const [subLedgerPageNumber, setSubLedgerPageNumber] = useState(1)
    const [subLedgerDataWithGroups, setSubLedgerDataWithGroups] = useState([])
    const [subLedgerWithGroupsPageNumber, setSubLedgerWithGroupsPageNumber] = useState(1)
    const [inventoryCount, setInventoryCount] = useState(0)
    const [inventoryList, setInventoryList] = useState([])
    const [subInventoryList, setSubInventoryList] = useState([])
    const [subInventoryCount, setSubInventoryCount] = useState(0)
    const [transactionList, setTransactionList] = useState({})
    const [transactionCount, setTransactionCount] = useState({})
    const [segments, setSegments] = useState(location.pathname.split('/').slice(3));
    const outSideClick = useRef();
    const validTypes = ['main', 'inventory', 'drill_down', 'group', 'mainGroup', 'sub-inventory', 'transaction']; // Add other valid types if any
    const allowedParams = [
        'main', 'type', 'dropname', 'filter', 'page_number', 'start_date', 'end_date', 'grand_total',
        'ledger_id', 'ay_id', 'class_id', 'section_id', 'inv_id', 'page_number_sub_inventory', 'student_id', 'student_uuid'
    ];
    const requiredGroupParams = ['main', 'dropname', 'filter', 'start_date', 'end_date'];
    const allowedDropnames = ['Financial Year', 'Academic Year', 'Custom'];
    const [FYLoading, setFYLoading] = useState(true);
    /**
     * The function `validateParams` checks if the provided search parameters meet certain criteria related
     * to required group parameters, allowed parameters, and predefined values for 'dropname'.
     * @returns The `validateParams` function returns a boolean value - `true` if all validation checks
     * pass, and `false` if any of the validation checks fail.
     */
    const validateParams = (searchParams) => {
        //if filter is applies all the filter params realted to filter should be present
        const presentRequiredParams = requiredGroupParams.filter(param => searchParams.has(param) && searchParams.get(param).trim() !== '');
        if (presentRequiredParams.length > 0 && presentRequiredParams.length !== requiredGroupParams.length) {
            return false;
        }
        if(location.pathname.split('/').slice(3).length === 3 && searchParams.get('type') !== 'mainGroup'){
            return false;
        }
        //Only the params we are using in this feature should be present
        for (let key of searchParams.keys()) {
            if (!allowedParams.includes(key)) {
                return false;
            }
        }
        //dropname has a predefined values it should be among them only
        if (searchParams.has('dropname') && !allowedDropnames.includes(searchParams.get('dropname'))) {
            return false;
        }
        //the page type should be valid
        const type = searchParams?.get('type') === null ? 'main' : searchParams.get('type');
        if (!validTypes.includes(type)) {
            return false;
        }
        return true;
    };
      
    /**
     * The function `ValidateParamsAndRedirect` checks if the URL search parameters are valid and redirects
     * to a 404 page if they are not.
     */
    const ValidateParamsAndRedirect = () => {
        const searchParams = new URLSearchParams(location.search);
        const isValid = validateParams(searchParams);
        if (!isValid) {
            navigate('/404');
        }
    };

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatMMDDate = (dateStr) => {
        if(dateStr === undefined || dateStr === '' || dateStr == null){
            return dateStr;
        }
        const [month, day, year] = dateStr.split(' ');
        const formattedDay = day.replace(',', '').padStart(2, '0'); // Ensure day is two digits
        return `${month} ${formattedDay}, ${year}`;
    };

    const exportBtnhandler = () => {
        if(exportBtnLoading || loading || inventoryTableLoading || subInventoryTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading)
        {
            return;
        }
        let mainGroup;
        let isExport = true;
        let itemID = null
        const pathSegments = window.location.pathname.split('/');
        if (pathSegments.includes('assets')) {
            mainGroup = 'Assets';
        } else if (pathSegments.includes('liabilities')) {
            mainGroup = 'Liabilities';
        }
        if(pageType === 'main' || location.pathname==='/financial-statements/balance-sheet'){
            getBalanceSheetViewAPICall(isExport);
        } else {
            setExportBtnLoading(false);
        }
        if(searchParams?.get('type') === 'inventory') getInventoryListAPICall(isExport)
        if(searchParams?.get('type') === 'sub-inventory') getSubInventoryListAPICall(itemID = null, isExport)
        if(searchParams?.get('type') === "group" || searchParams?.get('type') === 'mainGroup') getSubLedgerWithGroupsAPICall(mainGroup, isExport)
        if(searchParams?.get('type') === "drill_down") getSubLedgerAPICall(mainGroup, isExport)
        if(searchParams?.get('type') === 'transaction') getTransactionTableAPICall(mainGroup, isExport)
    }
    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };
    
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type && searchParams.get('filter') !== false) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('date_range')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            params.type = 'main'
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } else {
                params.dropname = 'Academic Year';
            }
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
            delete params?.ledger_id
            delete params?.ay_id
            delete params?.class_id
            delete params?.section_id
            delete params?.student_id
            delete params?.student_uuid
            delete params?.grand_total
            delete params?.page_number
            delete params?.page_number_sub_inventory
            delete params?.inv_id
            navigate(`/financial-statements/balance-sheet${
                Object.keys(params).length === 0 
                    ? '' 
                    : `?${new URLSearchParams(params).toString()}`}`)
            setPageType('main')
        } else {
            setSearchParams({})
            setSelectedDateRange('')
            setSelectedName('')
            setFilterCheckBox([])
            setSelectedFilter('date_range')
            navigate('/financial-statements/balance-sheet')
            setPageType('main')
        }
        getCount(type)
    }
    //----
    
    /**
     * The function `formatAndSetPath` takes a type, path, and subInventory flag, formats the path by
     * capitalizing words and replacing underscores with spaces, and returns the formatted string.
     * @returns The function `formatAndSetPath` returns a formatted string based on the input `type`,
     * `path`, and `subInventory`. If the `path` contains the specified `type`, it formats the path by
     * capitalizing the words and joining them with ' > '. If `subInventory` is true and it's the last
     * part of the path, it does not capitalize the last part. 
     */
    const formatAndSetPath = (type, path, lowercase) => {
        // Split the path into an array by '/'
        const pathArray = path.split('/');
        const startIndex = pathArray.indexOf(type);
        if (startIndex !== -1) {
            const relevantParts = pathArray.slice(startIndex);
            const formattedParts = relevantParts.map((part, index) => {
                // If it's the last part and lowercase is true, do not capitalize it
                if ( index !== 0 ) {
                    return part;
                } else {
                    return part.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                }
            });
            const formattedString = formattedParts.join(' > ');
            return formattedString;
        } else {
            console.error(`Path does not contain "${type}"`);
            return '';
        }
    };

    //API Calls----
    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    /**
     * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
     * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
     */
    const getAcademicYears = async() => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp = response?.data?.data?.data
        setAcademicYears(temp)
    }

    /* The below code is a React function component that defines a `getBalanceSheetViewAPICall` function
    using the `useCallback` hook. This function makes an asynchronous API call to retrieve balance sheet
    data based on certain parameters like branch ID, start date, and end date. */
    const getBalanceSheetViewAPICall = useCallback(async (isExport) => {
        try {   
            isExport ? setExportBtnLoading(true) : setLedgerTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `balance-sheet/view-balance-sheet?branch_id=${branch_id}${`${
                isExport ?`&export=true` : ''}${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
           
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data
            const temp2 = response?.data?.data?.start_date
            const temp3 = response?.data?.data?.end_date
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                setBalanceSheet(temp1)
                setBalanceSheetStartDate(temp2)
                setBalanceSheetEndDate(temp3)
                updateFilterCheckBox(); 
            } 
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setLedgerTableLoading(false)
            setExportBtnLoading(false)
            !isExport && navigate('/404')
        } finally{            
            !isExport && updateFilterCheckBox();
            setExportBtnLoading(false)
            setLoading(false)
            setLedgerTableLoading(false)
        }
    }, [searchParams, FYLoading]);

    /* The below code is a JavaScript React function using the `useCallback` hook. It is an asynchronous
    function `getInventoryListAPICall` that makes an API call to retrieve inventory data based on
    certain search parameters.*/
    const getInventoryListAPICall = useCallback(async (isExport) => {
        if(searchParams?.get('type') === 'inventory'){
            const ledgerPath = formatAndSetPath('assets', location.pathname, false)
            try {   
                isExport ? setExportBtnLoading(true) : setInventoryTableLoading(true)     
                const branch_id = await GetBranchId()
                let endpoint = `balance-sheet/inventory?branch_id=${branch_id}&ledger=${ledgerPath}${`${
                    isExport ?`&export=true` : ''}${
                    searchParams?.get('page_number') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number')}`}${
                    searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                    searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
                
                const response = await dataService.GetAPI(endpoint)
                const temp1 = response?.data?.data?.data
                const temp2 = response?.data?.data?.total_count
                const temp3 = response?.data?.data?.start_date
                const temp4 = response?.data?.data?.end_date
                if(isExport) {
                    setToastmessage(response?.data?.data?.message)
                    window.open(response?.data?.data?.pre_signed_url)
                } else {
                    if(response?.data?.data?.total_count === 0 || response?.data?.data?.data?.length === 0){
                        navigate('/financial-statements/balance-sheet')
                        setToastErrorMessage("Something went wrong")
                    }
                    setInventoryList(temp1)
                    setInventoryCount(temp2)
                    setBalanceSheetStartDate(temp3)
                    setBalanceSheetEndDate(temp4)
                    updateFilterCheckBox();  
                }
            } catch(error) {  
                if (error?.response?.status === 403) {
                    setToastErrorMessage('You are not authorized to perform this action')
                    navigate('/access-denied');
                    return;  
                }
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                console.log(error)
                setLoading(false)
                setExportBtnLoading(false)
                setInventoryTableLoading(false)
                !isExport && navigate('/404')    
            } finally{
                !isExport && updateFilterCheckBox();  
                setExportBtnLoading(false)              
                setLoading(false)
                setInventoryTableLoading(false)

            }
        } else {
            navigate('/financial-statements/balance-sheet')
        }
    }, [searchParams]);

    /* The below code is a JavaScript React function using the `useCallback` hook to make an asynchronous
    API call to retrieve a list of sub-inventory items.*/
    const getSubInventoryListAPICall = useCallback(async (itemID, isExport) => {
        const ledgerPath = formatAndSetPath('assets', location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : setSubInventoryTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `balance-sheet/view-inventory-transactions?branch_id=${branch_id}&inventory_id=${
                searchParams.get('inv_id') === null ? itemID : searchParams.get('inv_id')}&ledger=${ledgerPath}${`${
                isExport ?`&export=true` : ''}${
                searchParams?.get('page_number_sub_inventory') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number_sub_inventory')}`}${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.start_date
            const temp4 = response?.data?.data?.end_date
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                if((response?.data?.data?.total_count === 0 || response?.data?.data?.inward_and_outward?.length === 0) && (searchParams?.get('page_number_sub_inventory') !== null && searchParams?.get('page_number_sub_inventory') !== '1')){
                    navigate('/financial-statements/balance-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                setSubInventoryList(temp1)
                setSubInventoryCount(temp2)
                setBalanceSheetStartDate(temp3)
                setBalanceSheetEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setExportBtnLoading(false)
            setLoading(false)
            setSubInventoryTableLoading(false)
            !isExport && navigate('/404')    
        } finally{
            !isExport && updateFilterCheckBox();  
            setExportBtnLoading(false)          
            setLoading(false)
            setSubInventoryTableLoading(false)

        }
        // } else {
        //     navigate('/financial-statements/balance-sheet')
        // }
    }, [searchParams]);

    /* The below code is a JavaScript React function that makes an API call to retrieve subledger data with
    groups based on a main group parameter. Here is a breakdown of what the code is doing: */
    const getSubLedgerWithGroupsAPICall = useCallback(async (mainGroup, isExport) => {
        // if (!subLedgerWithGroupsHasMoreData) return;
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : subLedgerWithGroupsPageNumber === 1 && setSubLedgerWithGroupseLoading(true)   
            isExport ? setExportBtnLoading(true) : subLedgerWithGroupsPageNumber !== 1 && setInfiniteScrollLoading(true) 
            const branch_id = await GetBranchId()
            let endpoint = `balance-sheet/view-child?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${`${
                isExport ?`&export=true` : ''}${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data?.data
            const temp3 = response?.data?.data?.start_date
            const temp4 = response?.data?.data?.end_date
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                if(subLedgerWithGroupsPageNumber === 1 && response?.data?.data?.data?.length === 0){
                    navigate('/financial-statements/balance-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                // if (response?.data?.data?.data?.length === 0) {
                //     setSubLedgerWithGroupsHasMoreData(false); // No more data available
                // }
                // setSubLedgerDataWithGroups(prevItems=>[...prevItems,...response?.data?.data])
                // setSubLedgerWithGroupsPageNumber(prevPage => prevPage + 1);
                setSubLedgerDataWithGroups(temp1)
                setBalanceSheetStartDate(temp3)
                setBalanceSheetEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setInfiniteScrollLoading(false)
            setExportBtnLoading(false)
            setSubLedgerWithGroupseLoading(false)
            !isExport && navigate('/404')    
        } finally{
            !isExport && updateFilterCheckBox();        
            setExportBtnLoading(false)    
            setLoading(false)
            setSubLedgerWithGroupseLoading(false)

        }
    }, [searchParams, FYLoading]);

    /* The below code is a React function component that defines a `getSubLedgerAPICall` function using the
    `useCallback` hook. This function is an asynchronous function that makes an API call to retrieve
    subledger data based on the `mainGroup` parameter and various query parameters from the
    `searchParams`. */
    const getSubLedgerAPICall = useCallback(async (mainGroup, isExport) => {
        // if (!subLedgerHasMoreData) return;
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : subLedgerPageNumber === 1 && setSubLedgerLoading(true) 
            isExport ? setExportBtnLoading(true) : subLedgerPageNumber !== 1 && setInfiniteScrollLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `balance-sheet/view-student-details?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${
                isExport ?`&export=true` : ''}${
                searchParams.get('ledger_id')  === null ? '' : `&ledger_id=${searchParams.get('ledger_id') }`}${
                searchParams.get('ay_id')  === null ? '' : `&academic_year_id=${searchParams.get('ay_id') }`}${
                searchParams.get('class_id')  === null  ? '' : `&class_id=${searchParams.get('class_id')}`}${
                searchParams.get('section_id')  === null  ? '' : `&section_id=${searchParams.get('section_id')}`}${`${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data
            const temp4 = response?.data?.data?.end_date
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                if(subLedgerPageNumber === 1 && response?.data?.data?.data?.length === 0){
                    navigate('/financial-statements/balance-sheet')
                    setToastErrorMessage("Something went wrong")
                } 
                // if (response?.data?.data?.data?.length === 0) {
                //     setSubLedgerHasMoreData(false); // No more data available
                // }
                // setSubLedgerData(prevItems=>[...prevItems,...response?.data?.data])
                // setSubLedgerPageNumber(prevPage => prevPage + 1);
                setSubLedgerData(temp1)
                setBalanceSheetEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {  
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setLoading(false)
            setExportBtnLoading(false)
            setInfiniteScrollLoading(false)
            setSubLedgerLoading(false)
            !isExport && navigate('/404')    
        } finally{
            !isExport && updateFilterCheckBox();  
            setExportBtnLoading(false)          
            setLoading(false)
            setInfiniteScrollLoading(false)
            setSubLedgerLoading(false)

        }
    }, [searchParams, FYLoading]);

    /* The above code is a JavaScript React function that makes an API call to retrieve transaction data
    based on the main group provided. It sets up the necessary parameters for the API endpoint,
    including branch ID, main group, ledger path, and various search parameters like page number, ledger
    ID, academic year ID, class ID, section ID, student ID, start date, and end date. */
    const getTransactionTableAPICall = useCallback(async (mainGroup, isExport) => {
        const ledgerPath = formatAndSetPath(mainGroup?.toLowerCase(), location.pathname, true)
        try {   
            isExport ? setExportBtnLoading(true) : setTransactionTableLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `balance-sheet/view-transactions?branch_id=${branch_id}&main_parent=${mainGroup}&ledger=${ledgerPath}${
                isExport ?`&export=true` : ''}${
                searchParams?.get('page_number') === null ? `&page_number=1` : `&page_number=${searchParams?.get('page_number')}`}${
                searchParams.get('ledger_id')  === null ? '' : `&ledger_id=${searchParams.get('ledger_id') }`}${
                searchParams.get('grand_total')  === null && searchParams.get('ay_id')  === null ? '&is_students_details=false' : `&is_students_details=true`}${
                searchParams.get('ay_id')  === null ? '' : `&academic_year_id=${searchParams.get('ay_id') }`}${
                searchParams.get('class_id')  === null  ? '' : `&class_id=${searchParams.get('class_id')}`}${
                searchParams.get('section_id')  === null  ? '' : `&section_id=${searchParams.get('section_id')}`}${
                searchParams.get('student_uuid')  === null  ? '' : `&student_uuid=${searchParams.get('student_uuid')}`}${`${
                searchParams?.get('start_date') === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.start_date
            const temp4 = response?.data?.data?.end_date            
            if(isExport) {
                setToastmessage(response?.data?.data?.message)
                window.open(response?.data?.data?.pre_signed_url)
            } else {
                if(response?.data?.data?.total_count === 0  && (searchParams?.get('page_number') !== null && searchParams?.get('page_number') !== '1')){
                    navigate('/financial-statements/balance-sheet')
                    setToastErrorMessage("Something went wrong")
                }
                setTransactionList(temp1)
                setTransactionCount(temp2)
                setBalanceSheetStartDate(temp3)
                setBalanceSheetEndDate(temp4)
                updateFilterCheckBox();  
            }
        } catch(error) {
            // Check if the error status is 403, then navigate to /access-denied
            if (error?.response?.status === 403) {
                setToastErrorMessage('You are not authorized to perform this action')
                navigate('/access-denied');
                return;  // Exit the function to prevent further execution
            }
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setExportBtnLoading(false)
            setLoading(false)
            setTransactionTableLoading(false)
            !isExport && navigate('/404')    
        } finally{
            !isExport &&updateFilterCheckBox();   
            setExportBtnLoading(false)         
            setLoading(false)
            setTransactionTableLoading(false)

        }
    }, [searchParams, FYLoading]);

    /* The below code is using the `useEffect` hook in a React component to call the functions
    `getFinancialYears()` and `getAcademicYears()` when the component mounts. The `useEffect` hook is
    used to perform side effects in function components, such as fetching data, subscribing to events,
    or updating the DOM. In this case, the `useEffect` hook is being used with an empty dependency array
    `[]`, which means the effect will only run once when the component mounts. */
    useEffect(()=>{
        getFinancialYears()
        getAcademicYears()
    },[])

    /* The below code is a React useEffect hook that runs when the `location.pathname` changes. It converts
    the `searchParams` into an object, checks if the current path is
    '/financial-statements/balance-sheet', and if so, sets the `pageType` state to 'main' and updates
    the `searchParams` state with the new parameters. */
    useEffect(()=>{
        let params = Object.fromEntries(searchParams);
        if (location.pathname==='/financial-statements/balance-sheet'){
            setPageType('main')
            // Remove params.type before adding search parameters
            const searchParamsCopy = new URLSearchParams(searchParams);
            searchParamsCopy.delete('type');
        }
    }, [location.pathname])


    /* The below code is a React useEffect hook that runs when the component mounts or when the
    dependencies (`searchParams` and `location.pathname`) change. Here is a breakdown of what the code
    is doing: */
    useEffect(() => {
        if (startDate != null && !FYLoading) {
            const path = window.location.pathname;
            const onPopState = (event) => {
                // Remove the unwanted parameter
                window.history.replaceState({}, document.title, path);
            };
            ValidateParamsAndRedirect()
            if (
                path === '/financial-statements/balance-sheet' &&
                window.location.search.includes('type=') &&
                !window.location.search.includes('type=main')
            ) {
                window.addEventListener('popstate', onPopState);
                navigate('/financial-statements/balance-sheet')
                return () => window.removeEventListener('popstate', onPopState);
            } else {
                let mainGroup;
                let isExport = false;
                let itemID = null
                const pathSegments = window.location.pathname.split('/');
                if (pathSegments.includes('assets')) {
                    mainGroup = 'Assets';
                } else if (pathSegments.includes('liabilities')) {
                    mainGroup = 'Liabilities';
                }
                setPageType(searchParams?.get('type') === null ? 'main' : searchParams?.get('type'))
                if (pageType === 'main' || location.pathname === '/financial-statements/balance-sheet') {
                    getBalanceSheetViewAPICall(isExport);
                } else {
                    setLoading(false);
                }
                if (searchParams?.get('type') === 'inventory') getInventoryListAPICall(isExport)
                if (searchParams?.get('type') === 'sub-inventory') getSubInventoryListAPICall(itemID, isExport)
                if (searchParams?.get('type') === "group" || searchParams?.get('type') === 'mainGroup') getSubLedgerWithGroupsAPICall(mainGroup, isExport)
                if (searchParams?.get('type') === "drill_down") getSubLedgerAPICall(mainGroup, isExport)
                if (searchParams?.get('type') === 'transaction') getTransactionTableAPICall(mainGroup, isExport)
            }
        }
    }, [searchParams, location.pathname, startDate, FYLoading]);

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false);
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    return (
        <CardHeader noPadding>
            {/* top bar */} 
            <div className="mainDataCntnrTop shadow-s13">
                <div className="flex items-center">
                    <h5 class=" pageHeader adderror">
                        Balance Sheet
                    </h5>
                </div> 
                <div className='flex items-center'>
                    {<div class="relative">
                        <button 
                            disabled={loading || inventoryTableLoading || subInventoryTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading}
                            onClick={() => {
                                handleOpenFilter()
                            }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            finacialYear={finacialYear}  
                            academicYears={academicYears}
                            setSearchParams={setSearchParams} 
                            setStartDate={setStartDate} 
                            setEndDate={setEndDate}   
                            calculateEndDate={calculateEndDate}
                        />}
                    </div>}
                    {<button onClick={()=>{exportBtnhandler()}} id='export'
                        className={`prmy-btn export_btn`}>
                        {exportBtnLoading ? <Loader /> : 'Export'}
                    </button> }
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            {loading ? (
                <div>
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay max-h-[calc(100vh-70px)]" />
                </div>
            ) : (
                <div className="mainDataCntnrListDiv scrollBlue_thick">
                    <div className="fxd_heading">
                        {/* the end date is shown on the balance sheet as on date */}
                        <p>Balance Sheet as on <span id='balance_sheet_date' className="font-semibold ">{formatMMDDate(balanceSheetEndDate)}</span></p>
                    </div>
                    {/* This is the Nav Bar (Bread Crums) which appers when you drill down into the balance sheet */}
                    {pageType !== 'main' && (
                        <NavBar
                            balancesheet={balancesheet}
                            searchParams={searchParams}
                            pageType={pageType}
                            setPageType={setPageType}
                            isSchemeLedger={isSchemeLedger}
                            isLoading={loading || inventoryTableLoading || subInventoryTableLoading || transactionTableLoading || ledgerTableloading || subLedgerLoading || subLedgerWithGroupsLoading}

                        />
                    )}
                    {/* this codition when true will show the landing page of balance sheet */}
                    {pageType === 'main' && (
                        <div style={{'padding-top':'32px'}}>
                            {ledgerTableloading ? (
                                <div className="flex justify-between border border-[#C2DCEF] overflow-auto scroll-bar mb-10 min-h-[512px]">
                                    <div className="w-1/2 mr-[10px] min-w-[400px]">
                                        <ShimmerLedgerTable />
                                    </div>
                                    <div className="w-1/2 ml-4 min-w-[400px]">
                                        <ShimmerLedgerTable />
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="flex justify-between border border-[#C2DCEF] overflow-auto scroll-bar mb-10 min-h-[512px]">
                                        <div className="w-1/2 mr-[10px] min-w-[400px]">
                                            <LedgerTable
                                                mainHeading="Liabilities"
                                                ledgerData={balancesheet?.Liabilities?.items}
                                                totalBalance={balancesheet?.Liabilities?.balance}
                                                totalBalanceType={balancesheet?.Liabilities?.type}
                                                mainPath="bs/liabilities"
                                                searchParams={searchParams}
                                                setSearchParams={setSearchParams}
                                                setPageType={setPageType}
                                                setTransactionTableLoading={setTransactionTableLoading}
                                                setInventoryTableLoading={setInventoryTableLoading}
                                                setSubLedgerWithGroupseLoading={setSubLedgerWithGroupseLoading}
                                            />
                                        </div>
                                        <div className="w-1/2 ml-4 min-w-[400px]">
                                            <LedgerTable
                                                mainHeading="Assets"
                                                ledgerData={balancesheet?.Assets?.items}
                                                totalBalance={balancesheet?.Assets?.balance}
                                                totalBalanceType={balancesheet?.Assets?.type}
                                                mainPath="bs/assets"
                                                searchParams={searchParams}
                                                setSearchParams={setSearchParams}
                                                setPageType={setPageType}
                                                setTransactionTableLoading={setTransactionTableLoading}
                                                setInventoryTableLoading={setInventoryTableLoading}
                                                setSubLedgerWithGroupseLoading={setSubLedgerWithGroupseLoading}
                                            />
                                        </div>
                                    </div>
                                    {(balancesheet?.punched_in_ob_difference !== null &&
                                balancesheet?.punched_in_ob_difference !== undefined &&
                                balancesheet?.other_difference !== null &&
                                balancesheet?.other_difference !== undefined &&
                                (parseFloat(parseFloat(balancesheet.punched_in_ob_difference).toFixed(2)) !== 0.00 ||
                                    parseFloat(parseFloat(balancesheet.other_difference).toFixed(2)) !== 0.00)) && (
                                        <div className="mb-10">
                                            <p>Difference in punched opening balance: <span id='balance_sheet_punched_in_ob_difference'>{parseFloat(balancesheet?.punched_in_ob_difference).toFixed(2)}</span></p>
                                            <p>Other difference: <span id='balance_sheet_other_difference'>{parseFloat(balancesheet?.other_difference).toFixed(2)}</span></p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condtion when true will show the any sub ledger page after drilling down from the main page */}
                    {pageType === 'drill_down' && (
                        <div>
                            {subLedgerLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <SubLedgerTable
                                        Data={subLedgerData}
                                        getData= {getSubLedgerAPICall}
                                        infiniteScrollLoading={infiniteScrollLoading}
                                        setPageNumber={setSubLedgerPageNumber}
                                        searchParams={searchParams}
                                        setIsSchemeLedger={setIsSchemeLedger}
                                        formatMMDDate={formatMMDDate}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condtion when true will show the any sub group page after drilling down from the main page */}
                    {(pageType === 'group' || pageType === 'mainGroup')  && (
                        <div>
                            {subLedgerWithGroupsLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <SubLedgerTable
                                        Data={subLedgerDataWithGroups}
                                        getData= {getSubLedgerWithGroupsAPICall}
                                        infiniteScrollLoading={infiniteScrollLoading}
                                        setPageNumber={setSubLedgerWithGroupsPageNumber}
                                        searchParams={searchParams}
                                        setIsSchemeLedger={setIsSchemeLedger}
                                        formatMMDDate={formatMMDDate}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condition when true will show the main inventory table inside Assest > Current Assets > Inventory  */}
                    {pageType === 'inventory' && (
                        <div>
                            {inventoryTableLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <InventoryTable
                                        InventoryList={inventoryList}
                                        searchParams={searchParams}
                                        setSearchParams={setSearchParams}
                                        InventoryCount={inventoryCount}
                                        navigate={navigate}
                                        setPageType={setPageType}
                                        setPageLoading={setInventoryTableLoading}
                                        getSubInventoryListAPICall={getSubInventoryListAPICall}
                                        setSubInventoryTableLoading={setSubInventoryTableLoading}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condition when true will show the transaction table inside Assest > Current Assets > Inventory  */}
                    {pageType === 'sub-inventory' && (
                        <div>
                            {subInventoryTableLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <SubInventoryTable
                                        SubInventoryList={subInventoryList}
                                        searchParams={searchParams}
                                        setSearchParams={setSearchParams}
                                        SubInventoryCount={subInventoryCount}
                                        navigate={navigate}
                                        setPageType={setPageType}
                                        setPageLoading={setSubInventoryTableLoading}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {/* this condition when true will show the transaction table. The last page of any drill down from the main page */}
                    {pageType === 'transaction' && (
                        <div>
                            {transactionTableLoading ? (
                                <div className="">
                                    <ItemShimmer />
                                </div>
                            ) : (
                                <div>
                                    <TransactionTable
                                        TransactionList={transactionList}
                                        searchParams={searchParams}
                                        setSearchParams={setSearchParams}
                                        TransactionCount={transactionCount}
                                        setPageLoading={setTransactionTableLoading}
                                        formatMMDDate={formatMMDDate}
                                        formatDate={formatDate}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </CardHeader>
    )
}

export default BalanceSheet;